<template lang="pug">
  .field-subscription-id-and-client(v-if="$is('subscription-id-and-client')")
    .field-value {{item.id}}
    .field-value {{item.client.name}} {{item.client.surname}}

  .field-plan-name(v-else-if="$is('plan-name')")
    .field-value {{item.plan.name}}

  .field-subscription-booking-mode.iconized(v-else-if="$is('subscription-booking-mode')")
    i.pm-icon.subs-bookingtype
    .field-value {{item.plan.booking_mode}}

  .field-subscription-max-drivers.iconized(v-else-if="$is('subscription-max-drivers')")
    i.pm-icon.subs-drivers
    .field-value {{item.drivers.length}}/{{item.plan.max_drivers}}

  .field-expire-in(v-else-if="$is('subscription-expire-in')")
    .field-value(v-if="item.start && item.end") EXPIRE IN: {{item.start}} {{item.end}} {{$diffInDays(item.end, item.start)}} days
    .field-value(v-else) Unactive subscription
  .field-plan-billing-cycle.iconized(v-else-if="$is('plan-billing-cycle')")
    .field-value
      i.pm-icon.subs-billing
    .field-value */{{item.plan.billing_cycle}} days

  .field-auto-renew.iconized(v-else-if="$is('renew-info')")
    i.pm-icon.subs-expiry(v-bind:style="{color: item.auto_renew =='1' ? 'green' : 'red'}")
    .field-value(v-if="item.auto_renew =='1' && (item.start && item.end)") {{$diffInDays(item.start, item.end) -1}} days
    .field-value(v-else) Unactive/Disabled

  .field-plan-cost-billing-cycle(v-else-if="$is('plan-cost-billing-cycle')")
    .field-value
      strong {{item.plan.cost}}{{currency}}/{{$daysNumberToHuman(item.plan.billing_cycle)}}
</template>
<script type="text/babel">
  import {mapState} from 'vuex'

  export default {
    name: "SubscriptionFields",
    components: {},
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {
      type() {
        return this.fieldName
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
    props: {
      item: Object,
      fieldName: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// SubscriptionFields.vue?a9d53a0a